export enum AdminSecurityAuthenticationMethodEnum {
  "AuthenticatiorApp" = 1,
  "SMS" = 2,
}

export enum AdminSecurityEnum {
  // IP restriction levels
  IP_RESTRICTION_NONE = 0,
  IP_RESTRICTION_WHITELIST = 10,
  IP_RESTRICTION_BLACKLIST = 20,
  
  // Default values
  DEFAULT_SESSION_TIMEOUT = 3600, // 1 hour in seconds
  DEFAULT_ACCOUNT_LOCKOUT_DURATION = 1800, // 30 minutes in seconds
  DEFAULT_MAX_LOGIN_ATTEMPTS = 5,
  DEFAULT_PASSWORD_EXPIRATION_DAYS = 90,
  DEFAULT_MIN_PASSWORD_LENGTH = 8,
}
